export const LS_KEY_STORE = 'Store';
export const LS_KEY_PENDING_PROMO = 'pendingPromoCode';
